/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pIndexListItem.vue?vue&type=template&id=1593b64a&scoped=true"
import script from "./pIndexListItem.vue?vue&type=script&lang=js"
export * from "./pIndexListItem.vue?vue&type=script&lang=js"
import style0 from "./pIndexListItem.vue?vue&type=style&index=0&id=1593b64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593b64a",
  null
  
)

export default component.exports